import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ConstantsService } from '../constants.service';

@Injectable({
	providedIn: 'root'
})
export class HistoryService {
	constructor(private readonly http : HttpClient, private readonly constantsService : ConstantsService) { }
	loadDataHistory(periodId): Observable<any> {
		return this.http
			.get(`${this.constantsService.baseAPIURL}/gimanagement/history/${periodId}`, this.constantsService.httpCustomOptions)
			.pipe(
				catchError(this.handleError));
	}
	loadDataHistoryLogsDialog(queueId): Observable<any> {
		return this.http
			.get(`${this.constantsService.baseAPIURL}/gimanagement/getLogs/${queueId}`, this.constantsService.httpCustomOptions)
			.pipe(
				catchError(this.handleError));
	}
	deleteHistoryRecord(periodId, queueId): Observable<any> {
		return this.http
			.get(`${this.constantsService.baseAPIURL}/gimanagement/history/delete/${periodId}/${queueId}`, { headers: this.constantsService.httpOptions, responseType: 'text' })
			.pipe(
				catchError(this.handleError));
	}
	private handleError(error: HttpErrorResponse): Observable<never> {
		return throwError(() => error.message || 'Server Error');
	}

}